module.exports = __webpack_public_path__ + "img/notSignedCircle.119cde94.svg";